import {action, observable} from "mobx";

import reportTemplateService from "../services/reportTemplateService";
import appStore from "./appStore";

class ReportTemplateStore {
    @observable templatesByReportType = {};
    @observable loading = false;

    @action getTemplates = async reportType => {
        this.loading = true;
        try {
            const resultOfRequest = await reportTemplateService.getReportTemplates(reportType);
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data?.message || "Şablonlar yüklenemedi"});
                return [];
            }
            const templates = resultOfRequest.data || [];
            this.templatesByReportType[reportType] = templates;
            return templates;
        } finally {
            this.loading = false;
        }
    };

    @action createTemplate = async ({reportType, name, filters, selectedColumns}) => {
        this.loading = true;
        try {
            const resultOfRequest = await reportTemplateService.createReportTemplate({
                reportType,
                name,
                filters,
                selectedColumns,
            });
            if (resultOfRequest.status !== 201) {
                appStore.openErrorModal({content: resultOfRequest.data?.message || "Şablon oluşturulamadı"});
                return null;
            }
            const template = resultOfRequest.data;
            const templates = this.templatesByReportType[reportType] || [];
            this.templatesByReportType[reportType] = [...templates, template];
            return template;
        } finally {
            this.loading = false;
        }
    };

    @action updateTemplate = async ({id, reportType, name, filters, selectedColumns}) => {
        this.loading = true;
        try {
            const resultOfRequest = await reportTemplateService.updateReportTemplate({
                id,
                name,
                filters,
                selectedColumns,
            });
            if (resultOfRequest.status !== 200) {
                appStore.openErrorModal({content: resultOfRequest.data?.message || "Şablon güncellenemedi"});
                return null;
            }
            const updated = resultOfRequest.data;
            const templates = (this.templatesByReportType[reportType] || []).map(t =>
                t._id === id ? updated : t,
            );
            this.templatesByReportType[reportType] = templates;
            return updated;
        } finally {
            this.loading = false;
        }
    };

    @action deleteTemplate = async ({id, reportType}) => {
        this.loading = true;
        try {
            const resultOfRequest = await reportTemplateService.deleteReportTemplate(id);
            if (resultOfRequest.status !== 204) {
                appStore.openErrorModal({content: resultOfRequest.data?.message || "Şablon silinemedi"});
                return false;
            }
            const templates = (this.templatesByReportType[reportType] || []).filter(t => t._id !== id);
            this.templatesByReportType[reportType] = templates;
            return true;
        } finally {
            this.loading = false;
        }
    };

    @action markAsUsed = async templateId => {
        try {
            const resultOfRequest = await reportTemplateService.markReportTemplateAsUsed(templateId);
            if (resultOfRequest.status !== 200) {
                return false;
            }
            return true;
        } catch {
            return false;
        }
    };

    getTemplatesForReportType(reportType) {
        return this.templatesByReportType[reportType] || [];
    }
}

export default new ReportTemplateStore();
